import { useEffect, useState } from "react";
import { DEFAULT_MARKETPLACE_RANGE, formatPercent } from "../../../../constants/automapMarketplaceAnalyticsConstants";
import { fetchCampaignMarketplaceAnalytics } from "../../../../services/automapMarketplaceAnalyticsApi";
import { AnalyticsBreakdownTable } from "../AdminAnalyticsShared";
import { MarketplaceAnalyticsShell } from "./AdminMarketplaceAnalyticsShared";

export default function AdminCampaignAnalyticsPage() {
  const [range, setRange] = useState(DEFAULT_MARKETPLACE_RANGE);
  const [launchOnly, setLaunchOnly] = useState(false);
  const [payload, setPayload] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    setLoading(true);
    setError("");
    const filters = launchOnly ? { launchOnly: "true" } : {};
    fetchCampaignMarketplaceAnalytics(range, filters)
      .then(setPayload)
      .catch((err) => setError(err.message || "Error al cargar analytics."))
      .finally(() => setLoading(false));
  }, [range, launchOnly]);

  return (
    <MarketplaceAnalyticsShell
      active="campaigns"
      title="Analytics de campañas"
      description="Atribución por fuente, medio y campaña UTM."
      range={range}
      onRangeChange={setRange}
      viewEvent="campaign_analytics_viewed"
      toolbarExtra={
        <label className="dashboard-range-select" style={{ display: "flex", alignItems: "center", gap: "0.35rem" }}>
          <input
            type="checkbox"
            checked={launchOnly}
            onChange={(e) => setLaunchOnly(e.target.checked)}
          />
          Solo campaña launch
        </label>
      }
    >
      {payload?.costNote ? <p className="dealer-state-box muted">{payload.costNote}</p> : null}
      {loading ? <p className="dealer-state-box">Cargando…</p> : null}
      {error ? <p className="dealer-state-box">{error}</p> : null}
      {!loading && !error ? (
        <>
          {payload?.totals?.leads != null ? (
            <p className="muted" style={{ marginBottom: "0.75rem" }}>
              Leads en periodo: {payload.totals.leads} · Calificados: {payload.totals.qualifiedLeads ?? "—"}
              {launchOnly ? " · Filtro: launch campaign" : ""}
            </p>
          ) : null}
          <div className="admin-analytics-grid">
            <AnalyticsBreakdownTable title="Por fuente/medio" rows={payload.bySourceMedium} keyLabel="Fuente" />
            <AnalyticsBreakdownTable title="Por ciudad" rows={payload.byCity} keyLabel="Ciudad" />
            <AnalyticsBreakdownTable title="Por dealer" rows={payload.byDealer} keyLabel="Dealer" />
            <AnalyticsBreakdownTable title="Landing pages" rows={payload.topLandingPages} keyLabel="Página" />
          </div>
          <section className="dealer-state-box">
            <h3>Por campaña</h3>
            {!payload.byCampaign?.length ? (
              <p className="muted">Sin datos de campaña en este periodo.</p>
            ) : (
              <table className="dealer-inventory-table">
                <thead>
                  <tr>
                    <th>Campaña</th>
                    <th>Leads</th>
                    <th>Calificados</th>
                    <th>Conv.</th>
                  </tr>
                </thead>
                <tbody>
                  {payload.byCampaign.map((row) => (
                    <tr key={row.campaign}>
                      <td>{row.campaign}</td>
                      <td>{row.leads}</td>
                      <td>{row.qualifiedLeads}</td>
                      <td>{formatPercent(row.conversionRate)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </section>
        </>
      ) : null}
    </MarketplaceAnalyticsShell>
  );
}
